import { useQuery } from '@tanstack/react-query'
import { cartsService } from '../services/api'
import { useAuth } from '../contexts/AuthContext'
import { shouldRetryItems } from '../utils/itemQueryPolicy'
import { canReusePreviousQueryData, getUserId } from '../utils/sessionUser'

export function useCartsQuery(options = {}) {
  const { user, token } = useAuth()
  const userId = getUserId(user)
  const { enabled: enabledOption, queryFn, ...rest } = options

  return useQuery({
    queryKey: ['carts', userId],
    queryFn: async () => {
      const result = queryFn ? await queryFn() : await cartsService.list()
      if (!Array.isArray(result)) {
        throw new Error('Réponse paniers invalide')
      }
      const stillCurrent = getUserId(user)
      if (userId && stillCurrent && stillCurrent !== userId) {
        throw new Error('Réponse obsolète : la session utilisateur a changé')
      }
      return result
    },
    enabled: !!token && !!userId && enabledOption !== false,
    staleTime: 5000,
    retry: (failureCount, error) => shouldRetryItems(failureCount, error),
    retryDelay: 1000,
    placeholderData: (previousData, previousQuery) =>
      canReusePreviousQueryData(previousQuery, userId) ? previousData : undefined,
    ...rest,
  })
}
